import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PHRTrackerBloodOxygenDTO } from '../../../../generated';
import { IPHRPatientEnhanced } from '../../../../store/patient/phr/phrReducers';
import { phrBloodOxygensSelector } from '../../../../store/patient/phr/phrSelectors';
import { getAllForPhrSection } from '../../../../store/root-creator';
import { ReduxPHRCategoryEnum } from '../../../../store/types';
import PhrItem, { SecondaryInfoComponent } from '../../components/PhrItem';
import { VitalsTracker } from '../../vitals/components/PatientVitalsCard/usePatientVitalsCard';
import TrackerView from '../TrackerView';
import BloodOxygenChart from './BloodOxygenChart';
import BloodOxygenForm from './BloodOxygenForm';

interface IProps {
  patient: IPHRPatientEnhanced;
  renderHeader: (addButton?: any, onBack?: () => void, title?: string) => any;
  defaultBack?: any;
  defaultTitle?: string;
  showSingleTrackerForm?: (id: ReduxPHRCategoryEnum, tracker: VitalsTracker) => void;
}

const BloodOxygenComponent = ({
  patient,
  renderHeader,
  showSingleTrackerForm,
  defaultBack,
  defaultTitle,
}: IProps) => {
  const dispatch = useDispatch();
  const phrBloodPressures = phrBloodOxygensSelector(patient.phrBloodOxygens);

  useEffect(() => {
    if (patient) {
      dispatch(getAllForPhrSection(ReduxPHRCategoryEnum.PHRBloodOxygens, patient.patientID));
    }
  }, [dispatch, patient]);

  const thinView = (x: PHRTrackerBloodOxygenDTO, onView?: (data: any) => void) => (
    <>
      <PhrItem
        name={`${x.bloodOxygen}%`}
        isVerified={x.verified}
        onView={() => {
          if (onView) {
            onView(x);
          }
        }}
        SecondaryInfo={
          <SecondaryInfoComponent
            startDate={moment(x.trackerDate).toDate()}
            startDateTitle="Created on"
            showTime
          />
        }
      />
    </>
  );

  return (
    <TrackerView
      renderHeader={renderHeader}
      phrCategoryEnum={ReduxPHRCategoryEnum.PHRBloodOxygens}
      patient={patient}
      trackerData={phrBloodPressures}
      thinView={thinView}
      Chart={BloodOxygenChart}
      Form={BloodOxygenForm}
      createText="Blood Oxygen"
      showSingleTrackerForm={showSingleTrackerForm}
      defaultBack={defaultBack}
      defaultTitle={defaultTitle}
    />
  );
};

export default BloodOxygenComponent;
